/* Título de la página  */

//*react- recursos
import React from "react";
//npm install react-bootstrap --save-dev --force
//import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
//import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";

//*componentes-utiles


//*clases
  import '../../../css/mdi.css'; 
  
//*archivos (imagenes y elementos necesarios para la rutina)
//*api's (servicios y store)
//*store's
//*datos
//*funciones

//*interfaces
  interface propsContenidoTitulo {
    titulo: any;
    subtitulo: any;
    nota: any;
}

//*componente
  export default function ContenidoTitulo(props: propsContenidoTitulo) {
    //*api store
    //*store's
    //*datos
    //*constantes y variables
    //*usestate
    //*useEffect
    //*funciones
    //*vista
    return (
      <>
        <div>
          <h4 className="color-azul padding-botton-1r">{props.titulo}</h4>
          {props.subtitulo != null && 
            (<>
              <span className="subtitulo">{props.subtitulo}</span>
            </>)
          }
          {props.nota != null && 
            (<> 
              <p className="padding-botton-1r">
                <i className="mdi mdi-information-outline color-azul3"></i>
                {" "}
                <span id="propNota"   dangerouslySetInnerHTML={{  __html: props.nota,  }} ></span>
              </p>
            </>)
          }
        </div>
      </>
    )
  }
